import SchemaTreeViewWithButtons from "../../../shared/components/SchemaTreeViewWithButtons";
import useResource from "../../../shared/hooks/api/resource";

const Ontology = ({ values, setValues, editable }) => {
  const { updateResource } = useResource();

  const handleUpdate = () => {
    return updateResource({
      resourceId: values._id,
      body: {
        content: values.content,
      },
    });
  };

  return (
    <SchemaTreeViewWithButtons
      details={{
        resource_id: values._id,
        name: values.name,
        classification: values.classification,
        sub_classification: values.sub_classification,
      }}
      treeData={values.content}
      setTreeData={(treeData) =>
        setValues({
          ...values,
          content: treeData,
        })
      }
      editable={editable}
      onUpdate={handleUpdate}
      isRelationsTree={values.sub_classification === "relation"}
    />
  );
};

export default Ontology;
